import { getComponentConfiguration } from '../api/cmsApi';
import { setThemedCssVariables } from './setThemedCssVariables';

export const getConfigByMerchantCode  = async (merchantCode: string) => {
  const response = await getComponentConfiguration(merchantCode)
    .catch(() => {
      console.error(`Couldn't fetch transaction details component by the merchantCode ${merchantCode} from cms-api`)
      return null;
    });
  setThemedCssVariables(response?.data?.theme);
  return response?.data;
}
